import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {IPCourseLIst} from './interface/course.interface';
import {IPCourseSubmit} from './interface/ip-grading.interface';
import {IPStudentGradeValidationError, StudentGradeValidationError} from './interface/roster.interface';

@Injectable()
export class CourseRosterIpService {
    constructor(private http: HttpClient) {
    }

    getIPGradeCourse(termCode: string): Observable<IPCourseLIst> {
        return this.http.get<IPCourseLIst>('/api/courseRosterIP/' + termCode, {});
    }

    getIPGradeCourseByTermCodeAndCrn(termCode: string, crn: string): Observable<IPCourseLIst> {
        return this.http.get<IPCourseLIst>('/api/courseRosterIP/showByTermAndCrn/' + termCode + '/' + crn, {});
    }

    save(ipCourseData: Array<IPCourseSubmit>): Observable<IPStudentGradeValidationError> {
        const postData = { courseDataList: ipCourseData };

        return this.http.post<IPStudentGradeValidationError>('/api/courseRosterIP', postData);
    }
}
